<section class="pricing-page">
  <div class="container">
    <div class="section-head text-center">
      <h2>pricing guide</h2>
      <p>view live garment prices by service category.</p>
    </div>

    <div class="plan-section" *ngIf="!loading && !error">
      <div class="plan-section-label">plans</div>
      <div class="plan-tabs">
        <button type="button" class="plan-tab" [class.active]="isPlanActive('onetime')" (click)="selectPlan('onetime')">onetime</button>
        <button type="button" class="plan-tab" [class.active]="isPlanActive('subscription')" (click)="selectPlan('subscription')">subscription</button>
        <button type="button" class="plan-tab" [class.active]="isPlanActive('business')" (click)="selectPlan('business')">business</button>
      </div>
    </div>

    <div class="pricing-shell">
      <div class="status" *ngIf="loading">loading pricing...</div>

      <div class="status error" *ngIf="!loading && error">
        {{ error }}
      </div>

      <div class="service-tabs" *ngIf="!loading && !error && isPlanActive('onetime') && categories.length">
        <button
          type="button"
          class="service-tab"
          *ngFor="let category of categories; let i = index; trackBy: trackByIndex"
          [class.active]="isCategoryActive(category.key)"
          (click)="selectCategory(category.key)">
          {{ category.label | lowercase }}
        </button>
      </div>

      <div class="pricing-meta" *ngIf="!loading && !error && isPlanActive('onetime') && activeItems.length">
        <span class="meta-title">{{ getActiveCategoryLabel() | lowercase }}</span>
        <span class="meta-count">{{ activeItems.length }} items</span>
      </div>

      <div class="pricing-grid" *ngIf="!loading && !error && isPlanActive('onetime') && activeItems.length">
        <div class="pricing-item" *ngFor="let item of activeItems; let i = index; trackBy: trackByIndex">
          <span class="item-name">{{ item.name | lowercase }}</span>
          <span class="item-price">{{ item.displayPrice }}</span>
        </div>
      </div>

      <div class="plan-content" *ngIf="!loading && !error && isPlanActive('subscription')">
        <div class="plan-content-header">
          <div class="plan-visual" aria-hidden="true">
            <mat-icon>autorenew</mat-icon>
          </div>
          <span class="plan-chip">subscription</span>
          <h3>built for recurring personal care</h3>
          <p>save more with recurring pickup and delivery tailored to your weekly cleaning needs.</p>
        </div>

        <div class="plan-highlights">
          <div class="plan-highlight">
            <mat-icon>local_shipping</mat-icon>
            <span>scheduled pickup</span>
          </div>
          <div class="plan-highlight">
            <mat-icon>calendar_month</mat-icon>
            <span>monthly plans</span>
          </div>
          <div class="plan-highlight">
            <mat-icon>support_agent</mat-icon>
            <span>priority support</span>
          </div>
        </div>

        <div class="plan-content-grid">
          <div class="plan-block">
            <h4>
              <mat-icon>task_alt</mat-icon>
              <span>what you get</span>
            </h4>
            <ul>
              <li>priority scheduling for regular customers</li>
              <li>flat monthly plan options by garment volume</li>
              <li>dedicated support for plan updates and pauses</li>
              <li>consistent turnaround windows with route-based pickups</li>
              <li>personalized care preferences saved for repeat orders</li>
              <li>easy plan upgrades when your weekly volume changes</li>
            </ul>
          </div>

          <div class="plan-block">
            <h4>
              <mat-icon>route</mat-icon>
              <span>how it works</span>
            </h4>
            <ul>
              <li>choose your preferred pickup days and service categories</li>
              <li>we confirm your monthly plan based on expected garment count</li>
              <li>your recurring orders run automatically until you pause or change</li>
            </ul>
          </div>
        </div>

        <p class="plan-note">need flexibility? you can pause, resume, or change your schedule anytime.</p>
      </div>

      <div class="plan-content" *ngIf="!loading && !error && isPlanActive('business')">
        <div class="plan-content-header">
          <div class="plan-visual" aria-hidden="true">
            <mat-icon>business_center</mat-icon>
          </div>
          <span class="plan-chip">business</span>
          <h3>commercial care with predictable operations</h3>
          <p>flexible service for offices, hospitality, and partner organizations.</p>
        </div>

        <div class="plan-highlights">
          <div class="plan-highlight">
            <mat-icon>inventory_2</mat-icon>
            <span>volume handling</span>
          </div>
          <div class="plan-highlight">
            <mat-icon>payments</mat-icon>
            <span>consolidated billing</span>
          </div>
          <div class="plan-highlight">
            <mat-icon>handshake</mat-icon>
            <span>dedicated account team</span>
          </div>
        </div>

        <div class="plan-content-grid">
          <div class="plan-block">
            <h4>
              <mat-icon>workspace_premium</mat-icon>
              <span>business features</span>
            </h4>
            <ul>
              <li>custom pricing based on service frequency</li>
              <li>pickup and delivery windows for business hours</li>
              <li>account management and consolidated billing</li>
              <li>volume-based handling for uniforms, linens, and garments</li>
              <li>service-level planning for peak and off-peak periods</li>
              <li>dedicated operations contact for issue resolution</li>
            </ul>
          </div>

          <div class="plan-block">
            <h4>
              <mat-icon>groups</mat-icon>
              <span>ideal for</span>
            </h4>
            <ul>
              <li>hospitality teams and short-term rental operations</li>
              <li>corporate offices with regular garment care needs</li>
              <li>studios, clinics, and retail teams requiring routine cleaning</li>
            </ul>
          </div>
        </div>

        <p class="plan-note">for enterprise or multi-location accounts, request a custom onboarding plan.</p>
      </div>

      <div class="empty-state" *ngIf="!loading && !error && isPlanActive('onetime') && !activeItems.length">
        no pricing data available.
      </div>
    </div>
  </div>
</section>
